import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const Checkout24 = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        phone: '',
        paymentMethod: 'card',
        cardNumber: '',
        cardExpiry: '',
        cardCvv: '',
        cardName: '',
    });

    const steps = [
        { num: 1, label: 'Information' },
        { num: 2, label: 'Shipping' },
        { num: 3, label: 'Payment' },
    ];

    const orderItems = [
        { name: 'Silk Chanderi Drape', size: 'M', price: 14500, image: 'https://images.pexels.com/photos/8980747/pexels-photo-8980747.jpeg?auto=compress&cs=tinysrgb&w=200' },
        { name: 'The Monsoon Kurta', size: 'S', price: 7800, image: 'https://images.pexels.com/photos/6712369/pexels-photo-6712369.jpeg?auto=compress&cs=tinysrgb&w=200' },
    ];

    const subtotal = orderItems.reduce((s, i) => s + i.price, 0);
    const total = subtotal;

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        border: '1px solid #E5E5E5',
        fontFamily: "'Inter', sans-serif",
        fontSize: '14px',
        color: '#1A1A1A',
        background: '#FFFFFF',
        outline: 'none',
        transition: 'border-color 0.3s ease',
        boxSizing: 'border-box',
    };

    const labelStyle = {
        display: 'block',
        fontFamily: "'Inter', sans-serif",
        fontSize: '12px',
        fontWeight: 500,
        letterSpacing: '0.5px',
        color: '#6B6B6B',
        marginBottom: '8px',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-checkout {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-checkout-inner {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 48px 40px 120px;
                }
                .dhara-checkout-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 36px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 48px;
                    letter-spacing: -0.5px;
                }

                /* Steps */
                .dhara-checkout-steps {
                    display: flex;
                    align-items: center;
                    gap: 0;
                    margin-bottom: 60px;
                }
                .dhara-checkout-step {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    cursor: pointer;
                }
                .dhara-checkout-step-circle {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    transition: all 0.3s ease;
                }
                .dhara-checkout-step-label {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    letter-spacing: 0.5px;
                    transition: color 0.3s ease;
                }
                .dhara-checkout-step-line {
                    flex: 1;
                    height: 1px;
                    background: #E5E5E5;
                    margin: 0 24px;
                }

                /* Layout */
                .dhara-checkout-layout {
                    display: grid;
                    grid-template-columns: 1.3fr 1fr;
                    gap: 80px;
                    align-items: start;
                }
                .dhara-checkout-form-section {
                    /* form fields */
                }
                .dhara-checkout-field {
                    margin-bottom: 20px;
                }
                .dhara-checkout-row {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 16px;
                }
                .dhara-checkout-section-label {
                    font-family: 'Inter', sans-serif;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: #1A1A1A;
                    margin-bottom: 24px;
                    margin-top: 40px;
                }
                .dhara-checkout-section-label:first-child {
                    margin-top: 0;
                }
                .dhara-checkout-next-btn {
                    width: 100%;
                    height: 52px;
                    background: #00553A;
                    color: #FFFFFF;
                    border: none;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    cursor: pointer;
                    margin-top: 40px;
                    transition: background 0.3s ease;
                }
                .dhara-checkout-next-btn:hover {
                    background: #006B4A;
                }
                .dhara-checkout-back-btn {
                    width: 100%;
                    height: 48px;
                    background: transparent;
                    color: #6B6B6B;
                    border: none;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    cursor: pointer;
                    margin-top: 12px;
                    transition: color 0.3s ease;
                }
                .dhara-checkout-back-btn:hover {
                    color: #1A1A1A;
                }

                /* Order Summary Sidebar */
                .dhara-checkout-summary {
                    background: #FAFAF8;
                    padding: 40px;
                    position: sticky;
                    top: 100px;
                }
                .dhara-checkout-summary-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: #1A1A1A;
                    margin-bottom: 28px;
                }
                .dhara-checkout-summary-item {
                    display: flex;
                    gap: 16px;
                    margin-bottom: 20px;
                    align-items: start;
                }
                .dhara-checkout-summary-img {
                    width: 64px;
                    height: 80px;
                    object-fit: cover;
                    background: #FFFFFF;
                }
                .dhara-checkout-summary-item-name {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #1A1A1A;
                    margin-bottom: 4px;
                }
                .dhara-checkout-summary-item-detail {
                    font-family: 'Inter', sans-serif;
                    font-size: 12px;
                    color: #6B6B6B;
                }
                .dhara-checkout-summary-item-price {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #1A1A1A;
                    margin-left: auto;
                }
                .dhara-checkout-summary-divider {
                    height: 1px;
                    background: #E5E5E5;
                    margin: 20px 0;
                }
                .dhara-checkout-summary-row {
                    display: flex;
                    justify-content: space-between;
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    margin-bottom: 12px;
                }
                .dhara-checkout-summary-total {
                    display: flex;
                    justify-content: space-between;
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-top: 16px;
                    padding-top: 16px;
                    border-top: 1px solid #E5E5E5;
                }

                /* Payment methods */
                .dhara-checkout-payment-opt {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 16px;
                    border: 1px solid #E5E5E5;
                    margin-bottom: 12px;
                    cursor: pointer;
                    transition: border-color 0.3s ease;
                }
                .dhara-checkout-payment-opt.active {
                    border-color: #00553A;
                }
                .dhara-checkout-radio {
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    border: 2px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: border-color 0.3s ease;
                }
                .dhara-checkout-payment-opt.active .dhara-checkout-radio {
                    border-color: #00553A;
                }
                .dhara-checkout-radio-inner {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #00553A;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }
                .dhara-checkout-payment-opt.active .dhara-checkout-radio-inner {
                    opacity: 1;
                }
                .dhara-checkout-payment-label {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #1A1A1A;
                }

                input:focus {
                    border-color: #00553A !important;
                }

                @media (max-width: 768px) {
                    .dhara-checkout-inner { padding: 32px 20px 80px; }
                    .dhara-checkout-title { font-size: 28px; }
                    .dhara-checkout-layout {
                        grid-template-columns: 1fr;
                        gap: 40px;
                    }
                    .dhara-checkout-steps { gap: 0; }
                    .dhara-checkout-step-label { display: none; }
                    .dhara-checkout-row { grid-template-columns: 1fr; }
                    .dhara-checkout-summary { padding: 24px; }
                }
            `}</style>

            <Header24 />

            <main className="dhara-checkout">
                <div className="dhara-checkout-inner">
                    <h1 className="dhara-checkout-title">Checkout</h1>

                    {/* Steps */}
                    <div className="dhara-checkout-steps">
                        {steps.map((s, i) => (
                            <React.Fragment key={s.num}>
                                <div
                                    className="dhara-checkout-step"
                                    onClick={() => s.num < step && setStep(s.num)}
                                >
                                    <div
                                        className="dhara-checkout-step-circle"
                                        style={{
                                            background: step >= s.num ? '#00553A' : 'transparent',
                                            color: step >= s.num ? '#FFFFFF' : '#6B6B6B',
                                            border: step >= s.num ? '2px solid #00553A' : '2px solid #E5E5E5',
                                        }}
                                    >
                                        {step > s.num ? <Check size={14} strokeWidth={2} /> : s.num}
                                    </div>
                                    <span
                                        className="dhara-checkout-step-label"
                                        style={{ color: step >= s.num ? '#1A1A1A' : '#6B6B6B' }}
                                    >
                                        {s.label}
                                    </span>
                                </div>
                                {i < steps.length - 1 && <div className="dhara-checkout-step-line" />}
                            </React.Fragment>
                        ))}
                    </div>

                    <div className="dhara-checkout-layout">
                        {/* Form */}
                        <div className="dhara-checkout-form-section">
                            {step === 1 && (
                                <>
                                    <div className="dhara-checkout-section-label">Contact</div>
                                    <div className="dhara-checkout-field">
                                        <label style={labelStyle}>Email</label>
                                        <input
                                            style={inputStyle}
                                            type="email"
                                            value={formData.email}
                                            onChange={(e) => handleChange('email', e.target.value)}
                                            placeholder="your@email.com"
                                        />
                                    </div>
                                    <div className="dhara-checkout-field">
                                        <label style={labelStyle}>Phone</label>
                                        <input
                                            style={inputStyle}
                                            type="tel"
                                            value={formData.phone}
                                            onChange={(e) => handleChange('phone', e.target.value)}
                                            placeholder="+91"
                                        />
                                    </div>

                                    <div className="dhara-checkout-section-label">Shipping Address</div>
                                    <div className="dhara-checkout-row">
                                        <div className="dhara-checkout-field">
                                            <label style={labelStyle}>First Name</label>
                                            <input
                                                style={inputStyle}
                                                value={formData.firstName}
                                                onChange={(e) => handleChange('firstName', e.target.value)}
                                            />
                                        </div>
                                        <div className="dhara-checkout-field">
                                            <label style={labelStyle}>Last Name</label>
                                            <input
                                                style={inputStyle}
                                                value={formData.lastName}
                                                onChange={(e) => handleChange('lastName', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="dhara-checkout-field">
                                        <label style={labelStyle}>Address</label>
                                        <input
                                            style={inputStyle}
                                            value={formData.address}
                                            onChange={(e) => handleChange('address', e.target.value)}
                                        />
                                    </div>
                                    <div className="dhara-checkout-row">
                                        <div className="dhara-checkout-field">
                                            <label style={labelStyle}>City</label>
                                            <input
                                                style={inputStyle}
                                                value={formData.city}
                                                onChange={(e) => handleChange('city', e.target.value)}
                                            />
                                        </div>
                                        <div className="dhara-checkout-field">
                                            <label style={labelStyle}>State</label>
                                            <input
                                                style={inputStyle}
                                                value={formData.state}
                                                onChange={(e) => handleChange('state', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="dhara-checkout-field" style={{ maxWidth: '200px' }}>
                                        <label style={labelStyle}>Pincode</label>
                                        <input
                                            style={inputStyle}
                                            value={formData.pincode}
                                            onChange={(e) => handleChange('pincode', e.target.value)}
                                        />
                                    </div>

                                    <button className="dhara-checkout-next-btn" onClick={() => setStep(2)}>
                                        Continue to Shipping
                                    </button>
                                </>
                            )}

                            {step === 2 && (
                                <>
                                    <div className="dhara-checkout-section-label">Shipping Method</div>
                                    <div
                                        className="dhara-checkout-payment-opt active"
                                        style={{ marginBottom: '12px' }}
                                    >
                                        <div className="dhara-checkout-radio">
                                            <div className="dhara-checkout-radio-inner" style={{ opacity: 1 }} />
                                        </div>
                                        <div>
                                            <div className="dhara-checkout-payment-label">Standard Delivery</div>
                                            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: '#6B6B6B', marginTop: '4px' }}>
                                                5-7 business days &mdash; Complimentary
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dhara-checkout-payment-opt">
                                        <div className="dhara-checkout-radio">
                                            <div className="dhara-checkout-radio-inner" />
                                        </div>
                                        <div>
                                            <div className="dhara-checkout-payment-label">Express Delivery</div>
                                            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: '#6B6B6B', marginTop: '4px' }}>
                                                2-3 business days &mdash; {'\u20B9'}500
                                            </div>
                                        </div>
                                    </div>

                                    <button className="dhara-checkout-next-btn" onClick={() => setStep(3)}>
                                        Continue to Payment
                                    </button>
                                    <button className="dhara-checkout-back-btn" onClick={() => setStep(1)}>
                                        Return to Information
                                    </button>
                                </>
                            )}

                            {step === 3 && (
                                <>
                                    <div className="dhara-checkout-section-label">Payment</div>
                                    <div
                                        className={`dhara-checkout-payment-opt ${formData.paymentMethod === 'card' ? 'active' : ''}`}
                                        onClick={() => handleChange('paymentMethod', 'card')}
                                    >
                                        <div className="dhara-checkout-radio">
                                            <div className="dhara-checkout-radio-inner" />
                                        </div>
                                        <span className="dhara-checkout-payment-label">Credit / Debit Card</span>
                                    </div>
                                    <div
                                        className={`dhara-checkout-payment-opt ${formData.paymentMethod === 'upi' ? 'active' : ''}`}
                                        onClick={() => handleChange('paymentMethod', 'upi')}
                                    >
                                        <div className="dhara-checkout-radio">
                                            <div className="dhara-checkout-radio-inner" />
                                        </div>
                                        <span className="dhara-checkout-payment-label">UPI</span>
                                    </div>
                                    <div
                                        className={`dhara-checkout-payment-opt ${formData.paymentMethod === 'cod' ? 'active' : ''}`}
                                        onClick={() => handleChange('paymentMethod', 'cod')}
                                    >
                                        <div className="dhara-checkout-radio">
                                            <div className="dhara-checkout-radio-inner" />
                                        </div>
                                        <span className="dhara-checkout-payment-label">Cash on Delivery</span>
                                    </div>

                                    {formData.paymentMethod === 'card' && (
                                        <div style={{ marginTop: '28px' }}>
                                            <div className="dhara-checkout-field">
                                                <label style={labelStyle}>Card Number</label>
                                                <input
                                                    style={inputStyle}
                                                    placeholder="1234 5678 9012 3456"
                                                    value={formData.cardNumber}
                                                    onChange={(e) => handleChange('cardNumber', e.target.value)}
                                                />
                                            </div>
                                            <div className="dhara-checkout-field">
                                                <label style={labelStyle}>Name on Card</label>
                                                <input
                                                    style={inputStyle}
                                                    value={formData.cardName}
                                                    onChange={(e) => handleChange('cardName', e.target.value)}
                                                />
                                            </div>
                                            <div className="dhara-checkout-row">
                                                <div className="dhara-checkout-field">
                                                    <label style={labelStyle}>Expiry</label>
                                                    <input
                                                        style={inputStyle}
                                                        placeholder="MM / YY"
                                                        value={formData.cardExpiry}
                                                        onChange={(e) => handleChange('cardExpiry', e.target.value)}
                                                    />
                                                </div>
                                                <div className="dhara-checkout-field">
                                                    <label style={labelStyle}>CVV</label>
                                                    <input
                                                        style={inputStyle}
                                                        type="password"
                                                        placeholder="123"
                                                        value={formData.cardCvv}
                                                        onChange={(e) => handleChange('cardCvv', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <button className="dhara-checkout-next-btn" onClick={() => navigate('/template24/orders')}>
                                        Place Order
                                    </button>
                                    <button className="dhara-checkout-back-btn" onClick={() => setStep(2)}>
                                        Return to Shipping
                                    </button>
                                </>
                            )}
                        </div>

                        {/* Summary */}
                        <div className="dhara-checkout-summary">
                            <div className="dhara-checkout-summary-title">Your Order</div>
                            {orderItems.map((item, i) => (
                                <div key={i} className="dhara-checkout-summary-item">
                                    <img className="dhara-checkout-summary-img" src={item.image} alt={item.name} />
                                    <div>
                                        <div className="dhara-checkout-summary-item-name">{item.name}</div>
                                        <div className="dhara-checkout-summary-item-detail">Size: {item.size}</div>
                                    </div>
                                    <div className="dhara-checkout-summary-item-price">
                                        {'\u20B9'}{item.price.toLocaleString('en-IN')}
                                    </div>
                                </div>
                            ))}
                            <div className="dhara-checkout-summary-divider" />
                            <div className="dhara-checkout-summary-row">
                                <span>Subtotal</span>
                                <span>{'\u20B9'}{subtotal.toLocaleString('en-IN')}</span>
                            </div>
                            <div className="dhara-checkout-summary-row">
                                <span>Shipping</span>
                                <span>Complimentary</span>
                            </div>
                            <div className="dhara-checkout-summary-total">
                                <span>Total</span>
                                <span>{'\u20B9'}{total.toLocaleString('en-IN')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default Checkout24;
